import Vue from 'vue';
import VueRouter from 'vue-router';
import GiftList from '@/views/GiftList.vue';
import GiftDetail from '@/views/GiftDetail.vue';
import GiftUnbook from '@/views/GiftUnbook.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'GiftList',
    component: GiftList,
  },
  {
    path: '/darek/:id',
    name: 'GiftDetail',
    component: GiftDetail,
    props: true,
  },
  {
    path: '/darek/:id/zruseni-zamluveni',
    name: 'GiftUnbook',
    component: GiftUnbook,
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
